<template>
    <div>
        <b-modal ref="excluir-template"
        size="md"
        centered
        title="excluir template"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem"
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">EXCLUIR TEMPLATE</div>
        </template>
          <div class="container-new-template">

            <div class="font">Deseja proseguir com a exclusão do template <strong style="font: bold;">{{ template }}</strong>?</div>

            <div class="d-flex container_cancel_save">
              <div class="cancelar">
                  <button class="button-cancel">CANCELAR</button>
              </div>
              <div class="criar">
                <button class="button-save" @click="deleteTemplateWeb">DELETE</button>
              </div>
            </div>
          </div>
        </b-modal>
     </div>
</template>

<script>
import newTemplate from './deleteTemplate'
export default newTemplate
</script>

  <style scoped>
  .container-new-template{
    width: 100%;
  }
  .font {
    width: 100%;
    line-height: 1.5rem ;
    text-align: center;
    font-family: 'Segoe UI';
    font-size: 18px;
    color: #505050;
  }
  .header-title{
    color: white;
    font-size: 16px;
    font-weight: bold;
    font-family: 'Segoe UI';
  }
  .negrito {
    font-weight: bold;
  }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel,
  .button-save{
    margin-top: 1rem;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 35px;
    font-family: 'Segoe UI';
    font-size: 12px;
    font-weight: bold;
  }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/deleteTemplate/deleteTemplate.vue